import React from "react";
import { FeatureFlags } from "@/cms/models";
import RippleCtaButton from "../RippleCtaButton";
import LoadingRippleButton from "../LoadingRippleButton";

const FormLayout: React.FC<{
  children: React.ReactNode;
  formAction: any;
  isPending: boolean;
  submitLabel: string;
  backLabel?: string;
  onBack?: () => void;
  featureFlags?: FeatureFlags;
}> = ({
  children,
  formAction,
  isPending,
  submitLabel,
  onBack,
  backLabel,
  featureFlags,
}) => {
  return (
    <form noValidate action={formAction} className="flex flex-col gap-4 w-full">
      <div className="grid grid-cols-6 w-full gap-2">{children}</div>
      <div
        className={`flex col-span-6 gap-2 ${featureFlags?.reCAPTCHA ? "justify-between" : "justify-end"}`}
      >
        {featureFlags?.reCAPTCHA && (
          <div className="col-span-6 homepage-text-xs">
            Dette site er beskyttet af reCAPTCHA og Google’s{" "}
            <a
              className="underline"
              target="_blank"
              href="https://policies.google.com/privacy"
            >
              privatlivspolitik
            </a>{" "}
            og{" "}
            <a
              className="underline"
              target="_blank"
              href="https://policies.google.com/terms"
            >
              servicevilkår
            </a>{" "}
            gælder.
          </div>
        )}
        <div>
          {backLabel && onBack && (
            <RippleCtaButton onClick={() => onBack && onBack()}>
              {backLabel}
            </RippleCtaButton>
          )}
          <LoadingRippleButton
            config={{
              bgColor: "var(--form-button-bg-color)",
              textColor: "var(--form-button-text-color)",
              hoverBgColor: "var(--form-button-hover-bg-color)",
              hoverTextColor: "var(--form-button-hover-text-color)",
            }}
            loading={isPending}
            type="submit"
          >
            {submitLabel}
          </LoadingRippleButton>
        </div>
      </div>
    </form>
  );
};

export default FormLayout;
